'use client';
import React, { useEffect, useState } from 'react';
import { Modal, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { insertAnonymousUserId, logOut } from "../redux/slices/login"; // adjust path
import domainName from "../domainName";
import { useTranslation } from "react-i18next";

let memoryModalLock = false;

const AccountIssueModal = ({ show, onClose }) => {
  const dispatch = useDispatch();
  const [t, i18n] = useTranslation("global");
  const [isLoading, setIsLoading] = useState(false);
  const [localShow, setLocalShow] = useState(false);

  const checkModalLocked = () => {
    return memoryModalLock || localStorage.getItem('accountIssueModalLock') === 'true';
  };

  const lockModal = () => {
    memoryModalLock = true;
    localStorage.setItem('accountIssueModalLock', 'true');
  };

  const unlockModal = () => {
    memoryModalLock = false;
    localStorage.removeItem('accountIssueModalLock');
  };

  useEffect(() => {
    if (show && !checkModalLocked()) {
      lockModal();
      setLocalShow(true);
    }
  }, [show]);

  async function handleOkClick() {
    if (isLoading) return;
    setIsLoading(true);

    try {
      const response = await domainName
        .serverAPICall(
          domainName.debugAPI + "/user/insertAnonymouseUser",
          "POST"
        )
        .then(domainName.handleServerAPICallErrors);

      if (response.Data != null) {
        localStorage.setItem("advisorState", JSON.stringify({ advisor: false, user: true }));
        dispatch(logOut());
        dispatch(insertAnonymousUserId(response.Data._id));
      } else {
        alert(response.ReturnDesc);
      }

      onClose?.();

      setTimeout(() => {
        unlockModal();
        window.location.href = "/signin";
      }, 500);
    } catch (error) {
      alert(t("error.Oops!"), t("error.An error occurred. Please try again later."), error);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    const handleUnloadOrBack = () => {
      unlockModal();
    };

    window.addEventListener('beforeunload', handleUnloadOrBack);
    window.addEventListener('popstate', handleUnloadOrBack);

    return () => {
      window.removeEventListener('beforeunload', handleUnloadOrBack);
      window.removeEventListener('popstate', handleUnloadOrBack);
    };
  }, []);

  return (
    <Modal show={localShow} onHide={() => {}}  backdrop="static" keyboard={false} fade={false}>
      <Modal.Header>
        <Modal.Title>{t("accountSuspended.title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {t("accountSuspended.description")}{" "}
        <a href="mailto:support@adviser2u.com">support@adviser2u.com</a>
        {t("accountSuspended.mistake")}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleOkClick}>
          {t("accountSuspended.OK")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AccountIssueModal;
